"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MainMenuButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    return react_native_1.StyleSheet.create({
        button: {
            alignItems: 'center',
            backgroundColor: THEME.CardBackground,
            borderColor: THEME.CardBorder,
            borderWidth: 1,
            borderBottomWidth: 2,
            borderRadius: 4,
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'center',
            padding: 8
        },
        pressed: {
            backgroundColor: THEME.Secondary + '11',
            borderColor: THEME.Secondary + 'aa'
        }
    });
};
function MainMenuButton(props) {
    const styles = useStyles();
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { accessible: true, "aria-label": props["aria-label"], accessibilityHint: props.accessibilityHint, onPress: props.disabled ? (() => null) : props.onPress, style: ({ pressed }) => [
            styles.button,
            props.style,
            ((pressed && !props.disabled) ? (props.pressedStyle ?? styles.pressed) : null)
        ], children: props.children }));
}
